(function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            // AMD. Register as an anonymous module.
            define([], factory);
        } else if (typeof module === 'object' && module.exports) {
            // Node. Does not work with strict CommonJS, but
            // only CommonJS-like environments that support module.exports,
            // like Node.
            module.exports = factory();
        } else {
            // Browser globals (root is window)
            root.returnExports = factory();
        }
    }(typeof self !== 'undefined' ? self : this, function () {
        // Just return a value to define the module export.
        // This example returns an object, but the module
        // can return a function as the exported value.
        'use strict';
        var skins = {};
         skins['wysiwyg.common.components.spotifyfollow.viewer.skins.SpotifyFollowSkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "scrolling": "no",
        "frameBorder": 0,
        "allowtransparency": "true"
      }
    ],
    [
      "div",
      "placeholder",
      [
        "_hidden"
      ],
      {}
    ]
  ],
  "params": {
    "webThemeDir": "URL"
  },
  "paramsDefaults": {
    "webThemeDir": "WEB_THEME_DIRECTORY"
  },
  "css": {
    "%iframe": "overflow:hidden;border:0;",
    "%[data-state~=\"detailed_dark_show\"] %placeholder": "width:225px;height:56px;background:transparent url([webThemeDir]spotify/spotify_follow_placeholder_detailed_dark_show.png) 0 0 no-repeat;",
    "%[data-state~=\"detailed_dark_hide\"] %placeholder": "width:225px;height:56px;background:transparent url([webThemeDir]spotify/spotify_follow_placeholder_detailed_dark_hide.png) 0 0 no-repeat;",
    "%[data-state~=\"detailed_light_show\"] %placeholder": "width:225px;height:56px;background:transparent url([webThemeDir]spotify/spotify_follow_placeholder_detailed_light_show.png) 0 0 no-repeat;",
    "%[data-state~=\"detailed_light_hide\"] %placeholder": "width:225px;height:56px;background:transparent url([webThemeDir]spotify/spotify_follow_placeholder_detailed_light_hide.png) 0 0 no-repeat;",
    "%[data-state~=\"basic_all_show\"] %placeholder": "width:156px;height:25px;background:transparent url([webThemeDir]spotify/spotify_follow_placeholder_basic_all_show.png) 0 0 no-repeat;",
    "%[data-state~=\"basic_all_hide\"] %placeholder": "width:156px;height:25px;background:transparent url([webThemeDir]spotify/spotify_follow_placeholder_basic_all_hide.png) 0 0 no-repeat;"
  }
}

        return skins;
    }));